import CompanyButton from '@atoms/Button/CompanyButton';
import Icon from '@atoms/Icon/Icon';
import NavigationItem from '@atoms/NavigationItem/NavigationItem';
import useOnRouteChange from '@hooks/useOnRouteChange';
import { SolutionsMenuItem } from '@type-declarations/menu';
import isValidLink from '@utils/isValidLink';
import clsx from 'clsx';
import { useState } from 'react';

import styles from './MegaMenu.module.scss';

interface MegaMenuProps {
  menuItems?: SolutionsMenuItem[];
}

export default function MegaMenu({ menuItems = [] }: MegaMenuProps) {
  const [forceClosed, setForceClosed] = useState(false);

  useOnRouteChange(() => {
    setForceClosed(true);
    // Reset the force closed state after a brief delay to allow CSS transition
    setTimeout(() => {
      setForceClosed(false);
    }, 500);
  });

  return (
    <div
      className={clsx(
        styles.megaMenuContainer,
        forceClosed && styles.forceClosed,
      )}
    >
      <ul className={styles.menuList}>
        {menuItems.filter(isValidLink).map(item => (
          <li key={item.id} className={styles.menuItem}>
            {item.internalLink || item.externalLink ? (
              <NavigationItem item={item} className={styles.menuLink}>
                {item.title}
              </NavigationItem>
            ) : (
              <div className={styles.menuLink}>{item.title}</div>
            )}

            {(item.company || item.secondCompany) && (
              <div className={styles.companyButtonsContainer}>
                <CompanyButton
                  name={item.company}
                  internalLink={item.companyInternalLink}
                  externalLink={item.companyExternalLink}
                />
                <CompanyButton
                  name={item.secondCompany}
                  internalLink={item.secondCompanyInternalLink}
                  externalLink={item.secondCompanyExternalLink}
                />
              </div>
            )}

            <div className={styles.arrowContainer}>
              <Icon icon="arrow-right" className={styles.arrow} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
